export const Types = {
  SAVE_LIST_PERMISSION: 'SAVE_LIST_PERMISSION',
  SAVE_LIST_ROLE: 'SAVE_LIST_ROLE',
  SAVE_LIST_GROUP_PERMISSION: 'SAVE_LIST_GROUP_PERMISSION',
  SAVE_LIST_SET_PERMISSON: 'SAVE_LIST_SET_PERMISSON',
}
